<template>
    <el-dialog class="login-dialog-wrapper" title="" :visible.sync="innerData.visible" :close-on-click-modal="false" :append-to-body="true" width="800px" top="7vh" :lock-scroll="true" :show-close="false" :before-close="beforeClose">
        <div class="login-dlg">
            <div class="login-banner" :style="'background-image:url(' + require('@/web-framework/assets/images/login-icon.png') + ')'">
                <div>
                </div>
            </div>
            <div class="login-content-wrapper">
                <!-- 登录 -->
                <div class="login-content" v-show="activeTab == 'login'">
                    <div class="login-form-header">
                        <h3>{{siteInfo.SITE_NAME.value}}</h3>
                        <h5>Preferred Volunteer Analysis and Decision Service Platform</h5>
                    </div>

                    <!-- 账号方式登录 -->
                    <div class="login-form-box wx-login-box clearfix">
                        <template v-if="currentLoginMethod == 'user'">
                            <!-- 账号密码登录 -->
                            <div class="login-form" v-if="currentLoginFormType == 'account'">
                                <el-form ref="loginForm" :model="loginForm" :rules="loginRules" autocomplete="on" label-position="top">
                                    <el-form-item prop="account" label="用户名">
                                        <el-input class="w100" prefix-icon="el-icon-user" tabindex="1" type="text" placeholder="请输入用户名" v-model="loginForm.account" auto-complete="on" maxlength="20"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="password" class="mt20" label="密码">
                                        <el-input class="w100" prefix-icon="el-icon-lock" show-password v-model="loginForm.password" type="password" placeholder="请输入密码" tabindex="2" autocomplete="new-password" @keyup.enter.native="onClickLogin" maxlength="20"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="identityCode" class="mt20" v-if="loginFailedCount >= 3">
                                        <el-input class="w220" v-model="loginForm.identityCode" placeholder="请输入验证码" tabindex="3" @keyup.enter.native="onClickLogin" maxlength="6"></el-input>
                                        <div class="fr">
                                            <YushuVerifyCode ref="verifyCode"></YushuVerifyCode>
                                        </div>
                                    </el-form-item>
                                </el-form>
                                <div class="submit-container">
                                    <el-button class="w100 login-btn" type="primary" :loading="loading" @click.native.prevent="onClickLogin">登录</el-button>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <span class="btn-close" v-if="closable" @click="() => {innerData.visible = false;}">
                <i class="el-icon-close"></i>
            </span>

            <div style="bottom: 20px;width: 800px;position: fixed;justify-content: center;align-items: center;display: flex;text-align: center; color: #ffffff;">
                {{siteInfo.SITE_COPYRIGHT.value}}
            </div>
        </div>
    </el-dialog>
</template>
<script>
import SettingsAPI from '@/web-framework/api/settings.js';
import DictionaryAPI from '@/web-framework/api/dictionary.js';
import store from "@/public/store";
import WXAPI from "@/web-framework/api/weixin.js";
import UserFacedAPI from "@/web-framework/api/userfaced.js";
import { mapGetters } from "vuex";
export default {
    name: "YushuLoginDlg",
    props: ['data'],
    components: {
        YushuSendVerifyCodeButton: () => import('@/web-framework/components/YushuSendVerifyCodeButton/index.vue'),
        YushuVerifyCode: () => import("@/web-framework/components/YushuVerifyCode/index.vue")
    },
    data() {
        const confirmPwdValidator = (rule, value, callback) => {
            if (!value || value.length == 0) {
                callback(new Error("确认密码不能为空"));
            } else if (value != this.formInputNewPwd.newpwd) {
                callback(new Error("新密码与确认密码不符"));
            } else {
                callback();
            }
        };
        return {
            activeTab: 'login',
            siteInfo: {
                SITE_COPYRIGHT: {},
                SITE_NAME: {}
            },
            innerData: {
                visible: false
            },
            wxloginSettings: null,
            registLoading: false,
            allLoginMethods: [],
            currentLoginMethod: '',         // 当前登录方式
            currentLoginFormType: 'account',        // 当前登录表单类型：1-账号密码登录，2-手机验证码登录
            registType: 'pcPhone',                 // 注册方式：phone-手机号码注册，weixin-微信注册
            loading: false,
            findPwdLoading: false,
            resetPwdLoading: false,
            inpuNewPwd: false,
            loginFailedCount: 0,
            findPwdType: 'byPhone',
            loginForm: {
                account: "",
                password: "",
                identityCode: '',
            },
            registForm: {
            },
            formFindPwd: {
            },
            formInputNewPwd: {
            },
            loginRules: {
                identityCode: {
                    title: { required: true, message: "验证码不能为空", trigger: "blur" },
                }
            },
            registRules: {
                phone: [
                    { required: true, message: '输入手机号码', trigger: 'blur' },
                ],
                verifyCode: [
                    { required: true, message: '输入验证码', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '输入密码', trigger: 'blur' },
                ],
                name: [
                    { required: true, message: '输入企业名称', trigger: 'blur' },
                ],
            },
            findPwdByPhoneRules: {
                phone: [
                    { required: true, message: '输入手机号码', trigger: 'blur' },
                ],
                verifyCode: [
                    { required: true, message: '输入验证码', trigger: 'blur' },
                ]
            },
            findPwdByEmailRules: {
                email: [
                    { required: true, message: '输入邮箱', trigger: 'blur' },
                ]
            },
            formInputNewPwdRules: {
                newpwd: [
                    { required: true, message: '新密码不能为空', trigger: 'blur' },
                ],
                confirmPwd: [
                    { validator: confirmPwdValidator, trigger: 'blur' },
                ]
            },
            dlgDataVerifyCode: {
                visible: false
            }
        };
    },
    computed: {
        ...mapGetters({
            roles: "roles"
        }),
        loginMethodsToBeShown() {
            return this.allLoginMethods.filter(item => item.value != this.currentLoginMethod);
        }
    },
    watch: {
        currentLoginMethod(val) {
            if (val == 'weixin') {
                // 微信登录，刷新微信二维码
                this.refreshWeixinLoginQrcode();
            }
        },
        data: {
            deep: true,
            handler(value) {
                if (value) {
                    Vue.set(this, 'innerData', value);
                }
            }
        }
    },
    mounted() {
        this.init();
        if (this.tab && this.tab.length > 0) {
            this.activeTab = this.tab;
        }
    },
    methods: {
        beforeClose() {
            return false;
        },
        init() {
            Promise.all([DictionaryAPI.loadCodes('126'), SettingsAPI.getSetting('LOGIN_METHODS'), SettingsAPI.getSettings(['SITE_NAME', 'SITE_COPYRIGHT'])]).then(results => {
                let allLoginMethods = results[0].data || [];
                let enabledLoginMethods = JSON.parse(results[1].data.value);
                this.allLoginMethods = allLoginMethods.filter(item => enabledLoginMethods.indexOf(item.value) != -1);
                if (this.allLoginMethods.length > 0) {
                    let found = this.Utils.filterArray(this.allLoginMethods, 'value', 'user');
                    if (found && found.length > 0) {
                        this.currentLoginMethod = found[0].value;
                    } else {
                        this.currentLoginMethod = this.allLoginMethods[0].value;
                    }
                }

                if (results[2] && results[2].data) {
                    this.siteInfo = results[2].data;
                }
            });
        },
        refreshWeixinLoginQrcode() {
            this.$nextTick(() => {
                new Promise((resolve, reject) => {
                    if (this.wxloginSettings != null) {
                        resolve(this.wxloginSettings);
                    } else {
                        WXAPI.generateWxloginObj().then(result => {
                            if (result.success && result.data) {
                                this.wxloginSettings = result.data;
                                resolve(this.wxloginSettings);
                            }
                        });
                    }
                }).then(result => {
                    new WxLogin({
                        id: "qrcodeWrapper",
                        appid: result.appId,
                        scope: "snsapi_login",
                        redirect_uri: result.callbackUrl,
                        state: WXAPI.generateWxloginState('/u/'),
                        href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7CiAgICB3aWR0aDogMjAwcHg7CiAgICBtYXJnaW4tdG9wOiAwcHg7CiAgICBib3JkZXI6IDBweDsKfQouaW1wb3dlckJveCAudGl0bGUgewogICAgZGlzcGxheTogbm9uZTsKfQouaW1wb3dlckJveCAuaW5mbyB7CiAgICBkaXNwbGF5OiBub25lOwp9Ci5zdGF0dXNfaWNvbiB7CiAgICBkaXNwbGF5OiBub25lOwp9Ci5pbXBvd2VyQm94IC5zdGF0dXMgewogICAgdGV4dC1hbGlnbjogY2VudGVyOwp9Cg=="
                    });
                });
            });
        },
        // 打开对话框
        open() {
            this.innerData.visible = true;
        },
        close() {
            this.innerData.visible = false;
        },
        // 更换登录方式
        onClickChangeLoginMethod(loginMethod) {
            this.currentLoginMethod = loginMethod.value;
        },
        // 手机验证码登录
        onClickPhoneAndVerifyCodeLogin() {
            this.currentLoginFormType = 'verifyCode';
        },
        // 账号密码登录
        onClickAccountAndPwdLogin() {
            this.currentLoginFormType = 'account';
        },
        // 显示注册页面
        onClickShowRegist() {
            this.activeTab = 'regist';
        },
        // 显示登录界面
        onClickShowLogin() {
            this.activeTab = 'login';
        },
        onClickFindPwd() {
            this.activeTab = 'findPwdBy';
            this.inpuNewPwd = false;
        },
        onClickFindPwdByPhone() {
            this.formFindPwd = {};
            this.findPwdType = 'byPhone';
        },
        onClickFindPwdByEmail() {
            this.formFindPwd = {};
            this.findPwdType = 'byEmail';
        },
        // 微信扫码注册
        onClickShowWeixinRegist() {
            this.registType = 'pcWx';
        },
        // 手机号码注册
        onClickShowPhoneRegist() {
            this.registType = 'pcPhone';
        },
        // 点击注册
        onClickRegist() {
            this.$refs.registForm.validate(valid => {
                if (valid) {
                    this.registLoading = true;
                    store.dispatch("user/regist", { ...this.registForm, registType: this.registType }).then(result => {
                        this.registLoading = false;
                        this.innerData.visible = false;

                        if (this.roles && this.roles.length == 1) {
                            window.location = this.roles[0].entrancePath;
                        } else if (this.roles && this.roles.length > 0) {
                            let userRole = sessionStorage.getItem('currentUserRole');
                            if (userRole) {
                                let currentUserRole = JSON.parse(userRole);
                                window.location = currentUserRole.entrancePath;
                            } else {
                                window.location = this.roles[0].entrancePath;
                            }
                        }
                    }).catch(result => {
                        this.registLoading = false;
                        this.$message.warning(result.message || "验证失败，请重新登录");
                    });
                } else {
                    Vue.set(this, "loading", false);
                    return false;
                }
            });
        },
        // 登录
        onClickLogin() {
            if (this.loginFailedCount >= 3 && !this.$refs.verifyCode.isRight(this.loginForm.identityCode)) {
                this.$message.warning("验证码有误，请重新输入");
                this.$refs.verifyCode.refresh();
                return;
            }
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    this.loading = true;
                    store.dispatch("user/login", { ...this.loginForm, loginType: this.currentLoginFormType }).then(result => {
                        this.loading = false;
                        this.innerData.visible = false;
                        if (this.afterLogin) {
                            this.afterLogin();
                        } else {
                            if (result.entrancePath)
                                window.location.href = result.entrancePath;
                            else
                                window.location.href = '/404';
                        }
                    }).catch(result => {
                        if (this.loginFailedCount >= 3 && !this.$refs.verifyCode.isRight(this.loginForm.identityCode)) {
                            this.$refs.verifyCode.refresh();
                        }
                        this.$notify.warning({ title: '登录失败', message: result.message || "账号或密码有误，请重新登录" });
                        this.loading = false;
                        this.loginFailedCount++;
                    });
                } else {
                    Vue.set(this, "loading", false);
                    return false;
                }
            });
        },
        // 重置密码
        onClickRestPwd() {
            this.findPwdLoading = true;
            if (this.findPwdType == 'byPhone') {
                // 手机号找回密码，检验验证码是否正确
                this.$refs.formFindPwd.validate(valid => {
                    if (valid) {
                        UserFacedAPI.checkPhoneVerifyCode(this.formFindPwd.phone, this.formFindPwd.verifyCode, 'ResetPassword').then(result => {
                            this.findPwdLoading = false;
                            Request.validateResult(result, () => {
                                this.inpuNewPwd = true;
                                this.formInputNewPwd.code = result.data;
                                this.formFindPwd = {};
                            });
                        }).catch(error => {
                            this.findPwdLoading = false;
                            Request.validateCatchError(error);
                        });
                    } else {
                        this.findPwdLoading = false;
                        return false;
                    }
                });
            } else if (this.findPwdType == 'byEmail') {
                // 邮箱找回密码
                this.$refs.formFindPwd.validate(valid => {
                    if (valid) {
                        UserFacedAPI.sendPwdRestEmailByEmailAddress(this.formFindPwd.email).then(result => {
                            this.findPwdLoading = false;
                            Request.validateResult(result, () => {
                                this.$message.success("密码重置邮件已发送到您的邮箱，请根据邮件中的说明重置密码。");
                            });
                        }).catch(error => {
                            this.findPwdLoading = false;
                            Request.validateCatchError(error);
                        });
                    } else {
                        this.findPwdLoading = false;
                        return false;
                    }
                });
            }
        },
        onClickDoResetPwd() {
            this.$refs.formInputNewPwd.validate(valid => {
                if (valid) {
                    this.$confirm("您的密码将被重置，请确认您已牢记新的密码，确认继续吗？", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }).then(() => {
                        UserFacedAPI.changeUserPwdByPhone(this.formInputNewPwd).then(result => {
                            this.formInputNewPwd = {};
                            this.$message.success("密码修改成功，请重新登录！");
                            this.resetPwdLoading = false;
                            this.onClickShowLogin();
                        }).catch(error => {
                            this.resetPwdLoading = false;
                            Request.validateCatchError(error);
                        });
                    });
                } else {
                    this.resetPwdLoading = false;
                    return false;
                }
            });
        },
    }
};
</script>
<style lang="less" scoped>
.v-modal{
    opacity: .2 !important;
}
.login-dialog-wrapper {
    padding: 0px;
    /deep/.el-dialog {
        .el-dialog__header {
            padding: 0px;
            padding-bottom: 0px;
        }
        .el-dialog__body {
            padding: 0px;
        }
    }
}
.login-dlg {
    display: flex;
    flex-direction: row;
    width: 958px;
    height: 588px;
    background-color: #fff;
    background: #C2E1CF;
    overflow: hidden;

    .login-form {
        // padding-top: 36px;
        .remember {
            margin-top: 24px;
            height: 16px;
            cursor: pointer;
            color: #1261ff;
        }
        .submit-container {
            margin-top: 24px;
        }
        .el-form-item {
            .phone-prefix {
                position: absolute;
                width: 44px;
                height: 100%;
                top: 0;
                left: 0;
                z-index: 4;
                font-weight: 600;
                border-right: 1px solid #ececec;
                text-align: center;
                vertical-align: middle;
                display: inline-block;
                padding-top: 2px;
            }
            /deep/.phone-number {
                .el-input__inner {
                    padding-left: 54px;
                }
            }
        }
    }

    .login-banner {
        width: 284px;
        flex-shrink: 0;
        img {
            width: 100%;
            vertical-align: top;
        }
    }
    .login-content-wrapper {
        flex: 1;
        position: relative;
        border-radius: 30px 0px 0px 30px;
        background-color: #FFFFFF;
        .login-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding-top: 52px;
            padding-left: 48px;
            padding-right: 48px;
            .login-form-header {
                display: flex;
                flex-direction: column;
                margin-top:50px;
                justify-content: center;

                h3 {
                    line-height: 22px;
                    /* 文字/bold/32 */
                    font-family: Microsoft YaHei;
                    font-size: 32px;
                    font-weight: bold;
                    line-height: normal;
                    display: flex;
                    align-items: center;
                    letter-spacing: 0px;

                    font-variation-settings: "opsz" auto;
                    /* 主色1 */
                    color: #1E9F4D;
                    display: block;
                    text-align: center;
                    z-index: 0;
                }
                h5{
                    /* 文字/re/12 */
                    font-family: Microsoft YaHei;
                    font-size: 12px;
                    font-weight: normal;
                    line-height: normal;
                    display: flex;
                    align-items: center;
                    letter-spacing: 0px;

                    /* 主色1 */
                    color: #1E9F4D;
                    display: block;
                    text-align: center;
                }
                .header-tip {
                    font-size: 12px;
                    line-height: 12px;
                    color: #666;
                    margin-left: 16px;
                }
                .header-remark {
                    color: #1261ff;
                    cursor: pointer;
                    font-weight: 500;
                }
            }
            .login-form-box {
                width: 450px;
                height: 312px;
                padding-top: 16px;
                &.wx-login-box {
                    padding-top: 36px;
                }
            }
            .wx-login-box {
                .wx-login-header {
                    width: 100%;
                    height: 38px;
                    // padding-left: 30px;
                    margin: 0 auto 16px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }
                .wx-login-tip {
                    position: relative;
                    float: left;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    width: 153px;
                    height: 32px;
                    color: #666;
                    border: 1px solid #e6ebed;
                    border-radius: 4px 0 0 4px;
                    font-size: 12px;
                    &.is-checked {
                        font-weight: 600;
                        color: #333;
                        background-color: #f1f5f9;
                    }
                }
                .app-login-tip {
                    border-left: none;
                    border-radius: 0 4px 4px 0;
                }

                .qr-code-wrap {
                    width: 200px;
                    height: 200px;
                    margin: 0 auto;
                    /deep/iframe {
                        width: 200px;
                        height: 200px;
                    }
                    .yushu-wx-code {
                        position: relative;
                        width: 100%;
                        height: 100%;
                        .wx-over-time {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            text-align: center;
                            background-color: rgba(255, 255, 255, 0.9);
                            & > p {
                                position: absolute;
                                bottom: 0;
                                left: 0;
                                width: 100%;
                                height: 40px;
                                line-height: 40px;
                                color: #666;
                                font-size: 12px;
                                background-color: rgba(255, 255, 255, 0.8);
                            }
                        }
                        .wx-login-success,
                        .wx-register-success {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            background-color: rgba(255, 255, 255, 0.95);
                            padding-top: 40px;
                            img {
                                width: 56px;
                                height: 56px;
                            }
                            span {
                                color: #2ba245;
                                font-size: 16px;
                            }
                        }
                    }
                }
            }
            .other-login-line {
                position: relative;
                font-size: 14px;
                line-height: 24px;
                text-align: center;
                color: #999;
                .label {
                    position: relative;
                    z-index: 1;
                    width: 106px;
                    margin: 0 auto;
                    background: #fff;
                }
                .line {
                    position: absolute;
                    top: 12px;
                    left: 48px;
                    right: 48px;
                    border-top: 1px solid #e6ebed;
                }
            }
            .third-login {
                display: flex;
                flex-direction: row;
                justify-content: space-around;
                margin: 16px 20px 0 20px;
                .item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 48px;
                    white-space: nowrap;
                    cursor: pointer;
                    &:hover {
                        i {
                            color: #00c24c;
                        }
                    }

                    & > div {
                        width: 48px;
                        height: 48px;
                        border-radius: 50%;
                        background-color: #f5f7fa;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        i {
                            font-size: 20px;
                            color: #a1a1a1;
                            // width: 24px;
                            // height: 24px;
                        }
                    }
                    span {
                        color: #999;
                        font-size: 12px;
                        margin-top: 8px;
                    }
                }
            }
        }
    }
    .btn-close {
        position: absolute;
        right: 16px;
        top: 16px;
        font-size: 24px;
        cursor: pointer;
        color: #666;
    }
    /deep/.el-form-item__label{
        /* 文本色/高强调 */
        color: #2A2A2A;
        font-size: 18px;
        font-weight: bold;
    }
    /deep/.el-input__inner{
        height:64px;
        font-size:18px;
    }
    .login-btn{
        height: 64px;
        border-radius: 4px;
        background: #1E9F4D;
        /deep/span{
            font-family: Microsoft YaHei;
            font-size: 18px;
            font-weight: bold;
            line-height: 22px;
            text-align: center;
            align-items: center;
            letter-spacing: 0px;
            color: #FFFFFF;
        }
    }
    .login-icon{
        position: absolute;
        left: 96px;
        top: 428px;
        width: 90px;
        height: 87px;
        border-radius: 10px;
        opacity: 1;
        background-size: 165px 165px;
        background-position: -30px -30px;
        box-shadow: 8px 9px 27px 0px rgba(0, 74, 28, 0.73);
    }
}
</style>